import type { FaireProductEntity } from "../../entity_types/product";

export const p_9ptsuuoarf: FaireProductEntity = {
  token: "p_9ptsuuoarf",
  type: "product",
  name: "Organic Dried Mango, 6-pack case",
  brandToken: "b_3suuhjvzxi",
  brandName: "Mavuno Harvest Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/60fb94bd5c5c28ddc8063c475f572ae3fc9710dcdea1ef80b7f6e321b0296cd0.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/883b243eb94bed00c47606eeb2bb7a680c9ea9397ebf391dd6792b86e0ce6b0a.png",
    "https://cdn.faire.com/fastly/ff8fc76efcb45994723d75dd0c95897bc04c6db0c343fd7cdcb26d2acac16fc1.png",
    "https://cdn.faire.com/fastly/9b392a5573ccd3dca801705a0781840565eb91c7b037287e9cd812f4aa31ae7c.png",
    "https://cdn.faire.com/fastly/17d6fa67704b068d828ab3f1ae59fa810e3b85c3aae6d4e875ac66ba0261055d.png",
    "https://cdn.faire.com/fastly/1e154beb0f89c616590953def8f6dc7bc05f359d4ea629d8205e90e909a0a8d6.jpeg",
  ],
  priceDollars: 22.16,
  description:
    "A Sweet Taste of the Tropics — Anytime, Anywhere\n\nSun-ripened and naturally sweet, our organic dried mango is proof that the best snacks don’t need extras. Just one ingredient — mango — picked at peak ripeness from small farms in Ghana and gently dried to lock in that juicy, golden flavor.\n\nThese chewy, tangy slices are the kind of snack you’ll reach for again and again. Toss them in your bag for a hike, keep a pack at your desk, or share them straight from the bag at home. Wherever you are, a bite of Mavuno Harvest mango brings you a little burst of sunshine.\n\nIngredients\n\n * Organic dried mango \n * No preservatives \n * No added sugar \nWhy it Matters\n\nEvery bag comes from farmers who grow with care for the land and their communities. By choosing Mavuno Harvest, you’re not just snacking better — you’re supporting sustainable agriculture and fair partnerships across West Africa.\n\n\n",
  tags: [],
  msrpDollars: 36.01,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:34.949Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
